export const DEFAULT_NUMBERS = [
  { _id: '0', phoneNumber: '88808880080', price: 6149 },
  { _id: 1, phoneNumber: '88801101001', price: 2200 },
  { _id: 2, phoneNumber: '88801010107', price: 1701 },
  { _id: 3, phoneNumber: '88808888555', price: 1061 },
  { _id: 4, phoneNumber: '88801233321', price: 1051 },
  { _id: 5, phoneNumber: '88806930693', price: 583 },
  { _id: 6, phoneNumber: '88802021990', price: 525 },
  { _id: 7, phoneNumber: '88809929292', price: 495 },
  { _id: 8, phoneNumber: '88805551128', price: 457 },
  { _id: 9, phoneNumber: '88807657650', price: 442 },
  { _id: 10, phoneNumber: '88802730273', price: 350 },
  { _id: 11, phoneNumber: '88806079328', price: 287 },
  { _id: 12, phoneNumber: '88805916468', price: 280 },
  { _id: 13, phoneNumber: '88809132426', price: 280 },
  { _id: 14, phoneNumber: '88809564137', price: 270 },
  { _id: 15, phoneNumber: '88802507519', price: 268 },
  { _id: 16, phoneNumber: '88802470356', price: 267 },
  { _id: 17, phoneNumber: '88806827147', price: 267 },
  { _id: 18, phoneNumber: '88804073935', price: 266 },
  { _id: 19, phoneNumber: '88809792638', price: 264 },
  { _id: 20, phoneNumber: '88808059742', price: 263 },
  { _id: 21, phoneNumber: '88803957124', price: 263 },
  { _id: 22, phoneNumber: '88806130725', price: 262 },
  { _id: 23, phoneNumber: '88807206831', price: 257 },
  { _id: 24, phoneNumber: '88804813920', price: 256 },
  { _id: 25, phoneNumber: '88806793141', price: 256 },
  { _id: 26, phoneNumber: '88804923174', price: 254 },
  { _id: 27, phoneNumber: '88801423969', price: 254 },
  { _id: 28, phoneNumber: '88805942539', price: 254 },
  { _id: 29, phoneNumber: '88802945786', price: 252 },
  { _id: 30, phoneNumber: '88805649372', price: 252 },
  { _id: 31, phoneNumber: '88806954237', price: 252 },
  { _id: 32, phoneNumber: '88805743736', price: 243 },
  { _id: 33, phoneNumber: '88804692916', price: 233 },
  { _id: 34, phoneNumber: '88804363819', price: 210 },
  { _id: 35, phoneNumber: '88805349261', price: 210 },
  { _id: 36, phoneNumber: '88808316247', price: 198 },
  { _id: 37, phoneNumber: '88807976493', price: 182 },
  { _id: 38, phoneNumber: '88807207269', price: 130 },
  { _id: 39, phoneNumber: '88803919824', price: 111 },
  { _id: 40, phoneNumber: '88807491075', price: 105 },
  { _id: 41, phoneNumber: '88803037964', price: 99 },
  { _id: 42, phoneNumber: '88804721626', price: 93 },
  { _id: 43, phoneNumber: '88806936924', price: 69 },
  { _id: 44, phoneNumber: '88807960525', price: 56 },
  { _id: 45, phoneNumber: '88807652413', price: 51 },
  { _id: 46, phoneNumber: '88804572316', price: 36 },
  { _id: 47, phoneNumber: '88809697274', price: 36 },
  { _id: 48, phoneNumber: '88803219474', price: 32 },
  { _id: 49, phoneNumber: '88802161994', price: 32 },
  { _id: 50, phoneNumber: '88805135146', price: 31 },
  { _id: 51, phoneNumber: '88806381057', price: 31 },
  { _id: 52, phoneNumber: '88805627973', price: 30 },
  { _id: 53, phoneNumber: '88807975248', price: 26 },
  { _id: 54, phoneNumber: '88802470291', price: 23 },
  { _id: 55, phoneNumber: '88806568924', price: 22 },
  { _id: 56, phoneNumber: '88807971641', price: 21 },
  { _id: 57, phoneNumber: '88809476321', price: 21 },
  { _id: 58, phoneNumber: '88803507292', price: 16 },
  { _id: 59, phoneNumber: '88803859717', price: 16 },
  { _id: 60, phoneNumber: '88804725350', price: 15 },
  { _id: 61, phoneNumber: '88806267549', price: 15 },
  { _id: 62, phoneNumber: '88806515393', price: 15 },
  { _id: 63, phoneNumber: '88807168494', price: 15 },
  { _id: 64, phoneNumber: '88807360216', price: 15 },
  { _id: 65, phoneNumber: '88807974269', price: 14 },
  { _id: 66, phoneNumber: '88805917370', price: 10 },
  { _id: 67, phoneNumber: '88808032957', price: 9 },
  { _id: 68, phoneNumber: '88801010202', price: 200000 },
  { _id: 69, phoneNumber: '88803033333', price: 80000 },
  { _id: 70, phoneNumber: '88800000103', price: 50000 },
  { _id: 71, phoneNumber: '88800005757', price: 30000 },
  { _id: 72, phoneNumber: '88880404000', price: 30000 },
  { _id: 73, phoneNumber: '88800000080', price: 16000 },
  { _id: 74, phoneNumber: '88801181688', price: 15999 },
  { _id: 75, phoneNumber: '88800666666', price: 15555 },
  { _id: 76, phoneNumber: '88807456456', price: 8888 },
  { _id: 77, phoneNumber: '88808070605', price: 8888 },
  { _id: 78, phoneNumber: '88809248888', price: 8888 },
  { _id: 79, phoneNumber: '88811111993', price: 8800 },
  { _id: 80, phoneNumber: '88800888000', price: 8444 },
  { _id: 81, phoneNumber: '88808882220', price: 8000 },
  { _id: 82, phoneNumber: '88805200520', price: 6888 },
  { _id: 83, phoneNumber: '88805005555', price: 6666 },
  { _id: 84, phoneNumber: '88822221488', price: 6488 },
  { _id: 85, phoneNumber: '88801017171', price: 5500 },
  { _id: 86, phoneNumber: '88811112669', price: 5000 },
  { _id: 87, phoneNumber: '88800000144', price: 4999 },
  { _id: 88, phoneNumber: '88802029595', price: 4250 },
  { _id: 89, phoneNumber: '88802351488', price: 4200 },
  { _id: 90, phoneNumber: '88804201488', price: 4200 },
  { _id: 91, phoneNumber: '88807077070', price: 4200 },
  { _id: 92, phoneNumber: '88808008818', price: 3900 },
  { _id: 93, phoneNumber: '88800553535', price: 3850 },
  { _id: 94, phoneNumber: '88804200240', price: 3690 },
  { _id: 95, phoneNumber: '88804206990', price: 3690 },
  { _id: 96, phoneNumber: '88804696969', price: 2990 },
  { _id: 97, phoneNumber: '88802023636', price: 2888 },
  { _id: 98, phoneNumber: '88804950420', price: 2888 },
  { _id: 99, phoneNumber: '88807703131', price: 2888 },
  { _id: 100, phoneNumber: '88808800595', price: 2888 },
  { _id: 101, phoneNumber: '88809098686', price: 2888 },
  { _id: 102, phoneNumber: '88822223434', price: 2888 },
  { _id: 103, phoneNumber: '88800881100', price: 2590 },
  { _id: 104, phoneNumber: '88802463535', price: 2500 },
  { _id: 105, phoneNumber: '88808212121', price: 2490 },
  { _id: 106, phoneNumber: '88801306660', price: 2470 },
  { _id: 107, phoneNumber: '88804488440', price: 2448 },
  { _id: 108, phoneNumber: '88801515150', price: 2199 },
  { _id: 109, phoneNumber: '88802244660', price: 2100 },
  { _id: 110, phoneNumber: '88804295757', price: 2020 },
  { _id: 111, phoneNumber: '88800108108', price: 2000 },
  { _id: 112, phoneNumber: '88800764321', price: 1999 },
  { _id: 113, phoneNumber: '88807112233', price: 1999 },
  { _id: 114, phoneNumber: '88809866890', price: 1986 },
  { _id: 115, phoneNumber: '88800880369', price: 1888 },
  { _id: 116, phoneNumber: '88808723464', price: 1888 },
  { _id: 117, phoneNumber: '88805760576', price: 1800 },
  { _id: 118, phoneNumber: '88807073535', price: 1800 },
  { _id: 119, phoneNumber: '88803217755', price: 1799 },
  { _id: 120, phoneNumber: '88801234575', price: 1688 },
  { _id: 121, phoneNumber: '88807703434', price: 1666 },
  { _id: 122, phoneNumber: '88809092323', price: 1588 },
  { _id: 123, phoneNumber: '88802553399', price: 1490 },
  { _id: 124, phoneNumber: '88800144000', price: 1444 },
  { _id: 125, phoneNumber: '88801331337', price: 1337 },
  { _id: 126, phoneNumber: '88808252500', price: 1333 },
  { _id: 127, phoneNumber: '88809090923', price: 1288 },
  { _id: 128, phoneNumber: '88805935930', price: 1248 },
  { _id: 129, phoneNumber: '88802570257', price: 1200 },
  { _id: 130, phoneNumber: '88800112358', price: 1188 },
  { _id: 131, phoneNumber: '88800998877', price: 1000 },
  { _id: 132, phoneNumber: '88802466420', price: 999 },
  { _id: 133, phoneNumber: '88807451234', price: 999 },
  { _id: 134, phoneNumber: '88809102005', price: 999 },
  { _id: 135, phoneNumber: '88806160979', price: 990 },
  { _id: 136, phoneNumber: '88801234000', price: 950 },
  { _id: 137, phoneNumber: '88802133120', price: 950 },
  { _id: 138, phoneNumber: '88805077050', price: 900 },
  { _id: 139, phoneNumber: '88804343111', price: 890 },
  { _id: 140, phoneNumber: '88807473130', price: 890 },
  { _id: 141, phoneNumber: '88806951234', price: 888 },
  { _id: 142, phoneNumber: '88807591234', price: 888 },
  { _id: 143, phoneNumber: '88802128506', price: 850 },
  { _id: 144, phoneNumber: '88808420812', price: 812 },
  { _id: 145, phoneNumber: '88801015588', price: 800 },
  { _id: 146, phoneNumber: '88807155170', price: 777 },
  { _id: 147, phoneNumber: '88805348779', price: 700 },
  { _id: 148, phoneNumber: '88804101994', price: 690 },
  { _id: 149, phoneNumber: '88805432197', price: 690 },
  { _id: 150, phoneNumber: '88802937575', price: 688 },
  { _id: 151, phoneNumber: '88803927575', price: 688 },
  { _id: 152, phoneNumber: '88806273131', price: 688 },
  { _id: 153, phoneNumber: '88806915757', price: 688 },
  { _id: 154, phoneNumber: '88809747415', price: 666 },
  { _id: 155, phoneNumber: '88806064915', price: 600 },
  { _id: 156, phoneNumber: '88808804507', price: 600 },
  { _id: 157, phoneNumber: '88809128000', price: 600 },
  { _id: 158, phoneNumber: '88800683751', price: 567 },
  { _id: 159, phoneNumber: '88805679412', price: 567 },
  { _id: 160, phoneNumber: '88804753636', price: 558 },
  { _id: 161, phoneNumber: '88805376464', price: 558 },
  { _id: 162, phoneNumber: '88809669544', price: 544 },
  { _id: 163, phoneNumber: '88802507527', price: 527 },
  { _id: 164, phoneNumber: '88807649292', price: 500 },
  { _id: 165, phoneNumber: '88804175252', price: 499 },
  { _id: 166, phoneNumber: '88804586161', price: 499 },
  { _id: 167, phoneNumber: '88807243636', price: 499 },
  { _id: 168, phoneNumber: '88806271997', price: 490 },
  { _id: 169, phoneNumber: '88803526464', price: 466 },
  { _id: 170, phoneNumber: '88803924646', price: 466 },
  { _id: 171, phoneNumber: '88805957446', price: 400 },
  { _id: 172, phoneNumber: '88803217495', price: 399 },
  { _id: 173, phoneNumber: '88803217549', price: 399 },
  { _id: 174, phoneNumber: '88801314269', price: 390 },
  { _id: 175, phoneNumber: '88801641260', price: 390 },
  { _id: 176, phoneNumber: '88807410753', price: 377 },
  { _id: 177, phoneNumber: '88806320697', price: 366 },
  { _id: 178, phoneNumber: '88806920641', price: 366 },
  { _id: 179, phoneNumber: '88806950617', price: 366 },
  { _id: 180, phoneNumber: '88805470519', price: 355 },
  { _id: 181, phoneNumber: '88805146250', price: 350 },
  { _id: 182, phoneNumber: '88802054161', price: 333 },
  { _id: 183, phoneNumber: '88804249265', price: 333 },
  { _id: 184, phoneNumber: '88807064549', price: 333 },
  { _id: 185, phoneNumber: '88807172934', price: 333 },
  { _id: 186, phoneNumber: '88809264924', price: 333 },
  { _id: 187, phoneNumber: '88809631503', price: 290 },
  { _id: 188, phoneNumber: '88803571260', price: 288 },
  { _id: 189, phoneNumber: '88801395451', price: 280 },
  { _id: 190, phoneNumber: '88806193520', price: 280 },
  { _id: 191, phoneNumber: '88809217645', price: 280 },
  { _id: 192, phoneNumber: '88802574741', price: 277 },
  { _id: 193, phoneNumber: '88802746164', price: 277 },
  { _id: 194, phoneNumber: '88803715949', price: 277 },
  { _id: 195, phoneNumber: '88803752624', price: 277 },
  { _id: 196, phoneNumber: '88804165373', price: 277 },
  { _id: 197, phoneNumber: '88804297165', price: 277 },
  { _id: 198, phoneNumber: '88804358621', price: 277 },
  { _id: 199, phoneNumber: '88804637536', price: 277 },

];
